import React from "react";
import withStyles from '@mui/styles/withStyles';
import iconBlueClose from "../../assets/images/icon_blue_close.svg";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import KyteTecForm from "../Forms/KyteTecForm";

const topOffset = "10%";
const button = {
  border: "none",
  textTransform: "uppercase",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontWeight: 600,
  borderRadius: "30px",
  padding: "10px",
  width: "100%",
  color: "white",
  backgroundColor: "#8C8C96",
};
const block = {
  padding: "0px 60px 0px 60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  purchaseConfirmation: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    backgroundColor: "white",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
  },
  wrapper: {
    padding: "28px 0px 0px 0px",
  },
  block: block,
  blockWithDelimiter: {
    ...block,
    borderBottom: "1px solid #70707052",
  },
  blueText: {
    color: "#238CB9",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "12px",
    padding: "21px 0px",
  },
  button: button,
  buttonRed: {
    ...button,
    backgroundColor: "#D93140",
  },
  buttonWhite: {
    ...button,
    color: "#383838",
    backgroundColor: "#ffffff",
    border: "1px solid #707070",
  },
  couponCode: {
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "18px",
    padding: "8px 0px 30px 0px",
  },
});

const KyteTecModal = ({ classes, setShowPurchaseModal , couponCode, currentUser, discount}) => {
  useMakeScrollable("scrollable-modal");
  const { oneKeyId } = currentUser.data.currentUser.pharmacy
  return (
    <div id="scrollable-modal" className={classes.root}>
      <div className={classes.purchaseConfirmation}>
        <div style={{ position: "relative", top: "15px", right: "15px" }}>
          <img
            className={classes.closeIcon}
            src={iconBlueClose}
            alt="Close kytetecmodal modal"
            onClick={(e) => setShowPurchaseModal(false)}
          />
        </div>
        <KyteTecForm discount={discount} oneKeyId={oneKeyId} couponCode={couponCode} />
      </div>
    </div>
  );
};
export default withStyles(styles)(KyteTecModal);
